import { Button, Modal } from "antd";
import ReceiptExample from "../../../assets/images/receipt_example.png";

const ExampleModal = ({ open, setOpen }) => {
  return (
    <Modal
      title={null}
      onCancel={() => setOpen(false)}
      open={open}
      width={null}
      footer={null}
      style={{ top: "5vh" }}
    >
      <div
        style={{
          width: "90vw",
          height: "90vh",
          padding: "25px 0",
          textAlign: "center",
          direction: "rtl",
          fontSize: 15,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div>نمونه رسید ارسالی به مشتری</div>
        <div style={{ color: "red", fontSize: 14 }}>
          اطلاعات درج شده توسط شما در باکس گارانتی, در این فرم برای مشتری نمایش
          داده می‌شود.
        </div>
        <div>
          <img
            style={{
              width: 300,
              height: "60vh",
              margin: "10px 0",
              objectFit: "contain",
            }}
            src={ReceiptExample}
            alt="ReceiptExample"
          />
        </div>
        <div
          style={{
            width: "100%",
          }}
        >
          <Button
            style={{
              width: "45%",
              height: 40,
              borderRadius: 30,
              justifyContent: "center",
              alignItems: "center",
              borderWidth: 1,
              borderColor: "rgb(210, 210, 210)",
              backgroundColor: "#1e5279",
              opacity: 1,
              color: "white",
              cursor: "pointer",
              marginLeft: 8,
            }}
            onClick={() => setOpen(false)}
          >
            متوجه شدم
          </Button>
        </div>
      </div>
    </Modal>
  );
};
export default ExampleModal;
